"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observable = void 0;
const shared_1 = require("../shared");
class Observable {
    observers = new Map();
    storeValue;
    getFreezedValue() {
        return this.storeValue;
    }
    unsubscribeAll() {
        this.observers.clear();
    }
    unsubscribe(id) {
        this.observers.delete(id);
    }
    subscribe(observer) {
        const id = (0, shared_1.generateUniqueId)();
        this.observers.set(id, observer);
        if (this.storeValue) {
            this.emit(this.storeValue);
        }
        return {
            unsubscribe: () => {
                this.observers.delete(id);
            },
        };
    }
    emit(data) {
        if (typeof data !== 'object' && this.storeValue === data) {
            return;
        }
        for (const [key, observer] of Array.from(this.observers.entries())) {
            observer(data, key);
        }
        this.storeValue = data;
    }
    pipe(...transformFns) {
        const newObservable = new Observable();
        const newObserver = (data) => {
            let transformedData = data;
            for (const transformFn of transformFns) {
                transformedData = transformFn(transformedData);
            }
            newObservable.emit(transformedData);
        };
        this.subscribe(newObserver);
        return newObservable;
    }
}
exports.Observable = Observable;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JzZXJ2YWJsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wYWNrYWdlcy9yZWFjdGl2aXR5L29ic2VydmFibGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsc0NBQTZDO0FBSTdDLE1BQWEsVUFBVTtJQUNiLFNBQVMsR0FBcUMsSUFBSSxHQUFHLEVBQUUsQ0FBQztJQUN4RCxVQUFVLENBQWdCO0lBRWxDLGVBQWU7UUFDYixPQUFPLElBQUksQ0FBQyxVQUFVLENBQUM7SUFDekIsQ0FBQztJQUVELGNBQWM7UUFDWixJQUFJLENBQUMsU0FBUyxDQUFDLEtBQUssRUFBRSxDQUFDO0lBQ3pCLENBQUM7SUFFRCxXQUFXLENBQUMsRUFBVTtRQUNwQixJQUFJLENBQUMsU0FBUyxDQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUM1QixDQUFDO0lBRUQsU0FBUyxDQUFDLFFBQTZCO1FBQ3JDLE1BQU0sRUFBRSxHQUFHLElBQUEseUJBQWdCLEdBQUUsQ0FBQztRQUM5QixJQUFJLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxFQUFFLEVBQUUsUUFBUSxDQUFDLENBQUM7UUFFakMsSUFBSSxJQUFJLENBQUMsVUFBVSxFQUFFO1lBQ25CLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxDQUFDO1NBQzVCO1FBRUQsT0FBTztZQUNMLFdBQVcsRUFBRSxHQUFHLEVBQUU7Z0JBQ2hCLElBQUksQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQyxDQUFDO1lBQzVCLENBQUM7U0FDRixDQUFDO0lBQ0osQ0FBQztJQUVELElBQUksQ0FBQyxJQUFPO1FBQ1YsSUFBSSxPQUFPLElBQUksS0FBSyxRQUFRLElBQUksSUFBSSxDQUFDLFVBQVUsS0FBSyxJQUFJLEVBQUU7WUFDeEQsT0FBTztTQUNSO1FBRUQsS0FBSyxNQUFNLENBQUMsR0FBRyxFQUFFLFFBQVEsQ0FBQyxJQUFJLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLEVBQUUsQ0FBQyxFQUFFO1lBQ2xFLFFBQVEsQ0FBQyxJQUFJLEVBQUUsR0FBRyxDQUFDLENBQUM7U0FDckI7UUFFRCxJQUFJLENBQUMsVUFBVSxHQUFHLElBQUksQ0FBQztJQUN6QixDQUFDO0lBRUQsSUFBSSxDQUFJLEdBQUcsWUFBZ0M7UUFDekMsTUFBTSxhQUFhLEdBQUcsSUFBSSxVQUFVLEVBQUssQ0FBQztRQUUxQyxNQUFNLFdBQVcsR0FBd0IsQ0FBQyxJQUFJLEVBQUUsRUFBRTtZQUNoRCxJQUFJLGVBQWUsR0FBRyxJQUFJLENBQUM7WUFFM0IsS0FBSyxNQUFNLFdBQVcsSUFBSSxZQUFZLEVBQUU7Z0JBQ3RDLGVBQWUsR0FBRyxXQUFXLENBQUMsZUFBZSxDQUFVLENBQUM7YUFDekQ7WUFFRCxhQUFhLENBQUMsSUFBSSxDQUFDLGVBQXdCLENBQUMsQ0FBQztRQUMvQyxDQUFDLENBQUM7UUFFRixJQUFJLENBQUMsU0FBUyxDQUFDLFdBQVcsQ0FBQyxDQUFDO1FBRTVCLE9BQU8sYUFBYSxDQUFDO0lBQ3ZCLENBQUM7Q0FDRjtBQTVERCxnQ0E0REMifQ==